import { useEffect } from "react";
import { useThorView } from "@aviv-dxp/react-thor";
import { useI18n } from "@/contexts/i18n";
import { useConfig } from "@/contexts/cdpConfig";
import { IS_SERVER } from "@/constants";
export const useErrorTrackingView = (statusCode) => {
    const { env, trackingSite } = useConfig();
    const { locale } = useI18n();
    const path = IS_SERVER ? "" : window.location.pathname;
    const viewProps = {
        av_pagetitle: "classified_detail",
        av_category: "classified",
        av_environment: env,
        av_error_code: `${statusCode}`,
        av_url_path: path,
        av_language: locale,
        av_site: trackingSite,
        av_platform: "web",
        av_initiative: "wl_cdp",
    };
    // view object is subject to change so it's not listed as dep (to avoid sending the event twice)
    const view = useThorView({ viewProps });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(view, []);
};
